import Axios from "axios"
import cogoToast from "cogo-toast";
import APP_CONSTANT from '../../config/constants';
import { localStorageItems } from "../../utils/constant";

export const getCreditNote = async (page) => {
  try {
    let customer_no = localStorageItems.customerNo
    let user_id = localStorageItems.userId
    let data1 = JSON.stringify({
      "api_token": localStorageItems.apiToken,
      "customer_no": localStorageItems.customerNo,
      "user_id": localStorageItems.userId,
      "credit_note_id": null,
      "page":page
    })

    const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/credit-notes`, data1,{
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorageItems.apiToken,
        "Access-Control-Allow-Origin": "*"
      },
    });
    return data
  } catch {

  }
}


export const deleteCreditNote = (id) => {

  const userDeleteHeader = {
    customer_no: localStorage.getItem('customerNo'),
    user_id: localStorage.getItem('userId')

  }

  Axios.delete(`${APP_CONSTANT.BASE_URL}sales/credit-notes/delete/${id}`, {
    data: userDeleteHeader,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('isloggedIn')
    }
  }).then((response => {
    cogoToast.success(response.data.message)
    setTimeout(() => {
      window.location.reload()
    }, 500);

  }))
    .catch(error => console.log(error))
}